import moment, { Moment } from 'moment';

interface DateTimeDurationObject {
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
  milliseconds?: number;
  years?: number;
  months?: number;
  weeks?: number;
}

export default class DateTimeUtils {
  private rawDate: Moment;

  constructor(date?: string | Date | number, formatString?: string, utc?: boolean) {
    if (!utc) {
      this.rawDate = date ? this.parseDate(date, formatString) : moment();

      return;
    }

    this.rawDate = moment.utc(date);
  }

  public static now() {
    return new DateTimeUtils();
  }

  public static parse(date: string | Date | number, formatString?: string): DateTimeUtils {
    return new DateTimeUtils(date, formatString);
  }

  public format(formatString: string): string {
    return moment(this.rawDate).format(formatString);
  }

  public toDate(): Date {
    return this.rawDate.toDate();
  }

  public add(duration: DateTimeDurationObject): DateTimeUtils {
    this.rawDate = this.rawDate.add(duration);

    return this;
  }

  public isValid(): boolean {
    return this.rawDate.isValid();
  }

  private parseDate(date: string | Date | number, formatString?: string): Moment {
    return formatString
      ? moment(date, formatString, true)
      : moment(date);
  }
}
